// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-field-terms button{height:-moz-fit-content;height:fit-content}", ""]);
// Exports
module.exports = exports;
